export const PaymentMethod = {
  Monthly: 'Monthly',
  Subscription: 'Subscription',
  Single: 'Single',
  PaymentAssist: 'Subscription Payment'
} as const;

export const DocumentType = {
  IPID: 4,
  Policy: 3
} as const;

export const DocumentView = {
  Mobile: 'mobile',
  Desktop: 'desktop'
} as const;

export const CountryIsoCodes = {
  GB: 'gb',
  ES: 'es',
  DE: 'de',
  AT: 'at'
};

export const legacyUrls: string[] = [
  'alpinecarinsurance.co.uk',
  'daciacarinsurance.co.uk',
  'genesismotorinsurance.co.uk',
  'hyundaicarinsurance.co.uk',
  'kiacarinsurance.co.uk',
  'lotuscarinsurance.co.uk',
  'mazdacarinsurance.co.uk',
  'mitsubishicarinsurance.co.uk',
  'nissancarinsurance.co.uk',
  'originalinsurance.co.uk',
  'polestarinsurance.co.uk',
  'renaultcarinsurance.co.uk',
  'suzukicarinsurance.co.uk',
  'kiacustom.shop'
];

export enum PagesWithDropdown {
  AboutYouPage,
  AdditionalDriverDetailsPage,
  AddressDetailsPage,
  DrivingHistoryPage,
  InsuranceCoverDetailsPage,
  InsuranceVehicleDetailsPage,
  NeedHelpPage,
  YourQuotePage
}

export const Title = {
  Mr: 'Mr',
  Miss: 'Miss',
  Mrs: 'Mrs',
  Ms: 'Ms'
} as const;

export const Gender = {
  Male: 'M',
  Female: 'F',
  Unspecified: 'U'
} as const;

export const EmploymentStatus = {
  Retired: '12',
  HouseholdDuties: '8',
  IndependentMeans: '10',
  NotEmployedDueToDisability: '11',
  Unemployed: '2'
} as const;

export const WhoWillDrive = {
  InsuredOnly: 'INS',
  InsuredAndSpouse: 'INS_SPO',
  InsuredAndCivilPartner: 'INS_CP',
  InsuredAndPartnerSameAddress: 'INS_PAT'
} as const;

export const MaritalStatus = {
  Single: '2',
  Widowed: '4',
  Divorced: '5',
  Separated: '7'
} as const;

export const CarUses = {
  SDandP_Business_use_policy_holder_class_1: 'BUPIP',
  SDandP_Business_use_policy_holder_employer_or_name_driver: 'BUPADE',
  SDandP_Business_use_policy_holder_spouse_class_1: 'BUPS'
} as const;

export const Vendor = {
  FranchiseRetailer: 'FR'
} as const;

export const Source = {
  CustomerSelfRegistration: 'CUSTOMER-SELF-REGISTRATION',
  Mobilise: 'MOBILISE'
} as const;
